export const ERRORS_TEXTS = {
  unavailableService: 'Our services are unavailable now or internet connection has been lost',
  internalError: 'Internal Server Error'
};
